import { render, staticRenderFns } from "./SmsContactInfo.vue?vue&type=template&id=5b5f33b2&"
import script from "./SmsContactInfo.vue?vue&type=script&lang=js&"
export * from "./SmsContactInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports